

export enum WebServiceLayoutMetadataMethodType {
    GET = "GET",
    POST = "POST"
}

export enum WebServiceLayoutMetadataType {
    Select = "WS_SELECTOR_TYPE"
}

export const WebServiceLayoutMetadataTypeOptions = [
    { name: 'Selector', value: WebServiceLayoutMetadataType.Select }
]

export const WebServiceLayoutMetadataMethodTypeOptions = [
    { name: WebServiceLayoutMetadataMethodType.GET, value: WebServiceLayoutMetadataMethodType.GET },
    { name: WebServiceLayoutMetadataMethodType.POST, value: WebServiceLayoutMetadataMethodType.POST }
]